import { courseschedulesApi } from "api/courseSchedulesApi";
import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";

export const useCourseSchedule = (courseId: number, courseScheduleId: number) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_SCHEDULE_BY_ID(courseScheduleId!),
    queryFn: () => courseschedulesApi.fetchById(courseId, courseScheduleId),
    enabled: !!courseScheduleId,
  });
  return { isLoading, data: data?.data, refetch };
};
